import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuxiliarService } from 'src/app/_services/auxiliar.service';
import { ViajesService } from 'src/app/_services/viajes.service';
import { ModalMsgComponent } from '../modal-msg/modal-msg.component';

@Component({
  selector: 'app-tour-excursiones',
  templateUrl: './tour-excursiones.component.html',
  styleUrls: ['./tour-excursiones.component.css']
})
export class TourExcursionesComponent implements OnInit {
  idViaje: string;
  form: FormGroup;
  excursionesbd = [];
  
  submitted= false;

  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private viajesService: ViajesService,
    private auxService:AuxiliarService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
     //obtener parametro de url
     this.idViaje = this.activatedRoute.snapshot.params.id;
     //crear formularios
     this.form = this.formBuilder.group({
       excursiones: this.formBuilder.array([]),      
     });

     //recuperar datos
    this.cargarDatosViaje();
  }

  cargarDatosViaje(){
    this.viajesService.getExcursiones(this.idViaje).subscribe(data => {
      if(data instanceof HttpResponse) {
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones
        if(data.body.length > 0){
          var excursiones = data.body;     
          for (let i in excursiones) {             
            this.excursiones.push(this.createExcursion(excursiones[i])); 
            this.excursionesbd.push(excursiones[i].id);             
          }           
        }
        else {          
          this.addExcursion();          
        }        
      }
    });  

  }

  get excursiones():FormArray {
    return this.form.get('excursiones') as FormArray;
  };
  anadirExcursion(): FormGroup {
    return this.formBuilder.group({
      titulo: new FormControl('', Validators.required), 
      descripcion: new FormControl('', Validators.required),
      imagen:  new FormControl('', Validators.required), 
    });
  }
  createExcursion(data): FormGroup {
    var ext = '';
    if(data.imagen_excursion !== ''){
      ext = data.imagen_excursion.split('.')[1];
    }
    return this.formBuilder.group({
      titulo: new FormControl(data.titulo_excursion, Validators.required),     
      descripcion: new FormControl(data.descripcion_excursion, Validators.required), 
      imagen: new FormControl({
        localUrl: data.imagen,
        ext: ext, 
      }, Validators.required),      
    });
  }

  addExcursion() {
    this.excursiones.push(this.anadirExcursion());
  }
  deleteExcursion(index) {    
    this.excursiones.removeAt(index);
  }
  fileEvent(fileInput: any, index){
    if (fileInput.target.files.length > 0) {
      const file = fileInput.target.files[0];    
      
      var reader = new FileReader();
      reader.onload = (e: any) => {
        this.excursiones.controls[index].get('imagen').setValue({
          localUrl: e.target.result,
          ext: file.name.split('.')[1],
          toBig: file.size/1024/1024 > 2 ? true : false,
        });                             
       }
     reader.readAsDataURL(file); 
    }       
      
  } 

  imagesBig():boolean{
    var fileToBig = false;
    for (let control of this.excursiones.controls) {
     if(control.get("imagen").value.toBig){
       fileToBig = true;
     }
    }

    return fileToBig;
  }
  salvar(){
    this.submitted = true;
    //this.errorService = false;

    // stop here if form is invalid
    if (this.form.invalid || this.imagesBig()) {
      if(this.imagesBig()){
        const modalRef = this.modalService.open(ModalMsgComponent, { 
          centered: true,  
          backdrop:'static',      
        });
        modalRef.componentInstance.titulo = 'Existen imagenes mayores de 2MB';
        modalRef.componentInstance.label = 'Volver';
        return;
      }
        return;
    }
     //guardar excursiones
    if(this.excursionesbd.length) {//eliminar excursiones del paquete
      this.viajesService.deleteExcursiones(this.excursionesbd).subscribe(data => {
        if(data instanceof HttpResponse) {
          //verificar token
          if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
            this.auxService.sessionExpired();
          }
          //acciones
        }
      });
    }
    if(this.excursiones.length > 0 && this.idViaje !=='0'){      
      this.viajesService.insertarExcursion(this.idViaje,this.form.value).subscribe(data => {
        if(data instanceof HttpResponse) {
          //verificar token
          if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
            this.auxService.sessionExpired();
          }
          //acciones
          //aqui actualizar los id de ls actividades creadas
          this.excursionesbd=data.body.list; 
          const modalRef = this.modalService.open(ModalMsgComponent, { 
            centered: true,  
            backdrop:'static',      
          });
          modalRef.componentInstance.titulo = 'Excursiones agregadas';
          modalRef.componentInstance.check = 1; 
          modalRef.componentInstance.label = 'Aceptar';
          this.submitted = false;         
        }
      });
    } 
  }

}
